import axios from '@plugins/axios'
import config from '@src/app.config'
const env = config.env
const appConfig = config[env]

let serverUrl = appConfig.server_url

export const state = {
  questionsPages: { results: [] },
  page: {},
}

export const getters = {
  // questionsPages: (state) => state.questionsPages,
  page: (state) => state.page,
}

export const mutations = {
  // CACHE_QUESTIONS_PAGES(state, data) {
  //   state.questionsPages = data
  // },
  CACHE_PAGE(state, data) {
    state.page = data
  },
}

export const actions = {
  // async fetchOrganizationCharts({ commit }, query = '') {
  //   try {
  //     const res = await axios.get(`${serverUrl}/assessment/question_pagination/${query}`)
  //     commit('CACHE_QUESTIONS_PAGES', res.data)
  //     return { error: null, data: res.data }
  //   } catch (error) {
  //     return { error, data: null }
  //   }
  // },

  getQuestionPage({ commit }, { url, pageId }) {
    if (!url) {
      url = `${serverUrl}/assessment/question_pagination/${pageId}/`
    }
    return axios.get(url).then((res) => {
      commit('CACHE_PAGE', res.data)
      return res.data
    })
  },
}
